import script from "./empty.vue?vue&type=script&setup=true&lang=ts"
export * from "./empty.vue?vue&type=script&setup=true&lang=ts"

import "./empty.vue?vue&type=style&index=0&id=0e8dc608&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8dc608"]])

export default __exports__